export default "__VITE_ASSET__4ef45e78__"